"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgStampFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M8 6.364c0 1.494.313 2.25.653 3.07.075.182.152.368.227.566h6.24c.075-.198.152-.384.228-.566.34-.82.652-1.576.652-3.07C16 2.654 12.889 2 12 2c-.889 0-4 .655-4 4.364zM9.474 13c-.02-.368-.052-.7-.092-1h5.236c-.04.3-.072.632-.092 1H20a2 2 0 012 2v4H2v-4a2 2 0 012-2h5.474zM20 20.5a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 014 20.5V20h16v.5z' }))); };
exports.default = SvgStampFilled;
//# sourceMappingURL=StampFilled.js.map